/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { BadgeVariants } from '@ods/system';
import { ZertifikatStatus } from './zertifikat.model';

export interface StatusBadge {
  name: string;
  variant: BadgeVariants['variant'];
  color: BadgeVariants['color'];
}

export const STATUS_BADGES: Record<ZertifikatStatus, StatusBadge> = {
  [ZertifikatStatus.AKTIV]: { name: 'Aktiv', variant: 'primary', color: 'success' },
  [ZertifikatStatus.ABLAUFEND]: { name: 'Aktiv', variant: 'primary', color: 'success' },
  [ZertifikatStatus.WIDERRUFEN]: { name: 'Widerrufen', variant: 'primary', color: 'warning' },
  [ZertifikatStatus.ABGELAUFEN]: { name: 'Abgelaufen', variant: 'primary', color: 'error' },
};

export const UNKNOWN_STATUS_BADGE: StatusBadge = { name: 'Unbekannt', variant: 'outline', color: 'primary' };
